export const FETCH_PERMISSION_GROUPS_SUCCESS = 'fetch_permissions_groups_success'
export const CREATE_PERMISSION_GROUP_SUCCESS = 'create_permission_group_success'
export const EDIT_PERMISSION_GROUP_SUCCESS = 'edit_permission_group_success'
export const FETCH_PERMISSION_GROUP_DETAILS_SUCCESS = 'fetch_permission_group_details_success'
export const FETCH_PERMISSION_GROUP_USERS_SUCCESS = 'fetch_permission_group_users_success'
